import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import type { FormSectionUI } from "../utils";
import { SECTION_TITLES } from "../utils";
import { useLessonForm } from "./LessonFormContext";
import BlockItem from "./BlockItem";

interface ActivitySectionViewProps {
  section: FormSectionUI;
  sectionIndex: number;
  activityIndex: number;
}

const ActivitySectionView: React.FC<ActivitySectionViewProps> = ({
  section,
  sectionIndex,
  activityIndex,
}) => {
  const { addSectionBlock, removeSectionBlock } = useLessonForm();

  return (
    <div className="section-container">
      <h4 className="section-title">{SECTION_TITLES[section.section_type]}</h4>

      {section.blocks.map((block, blockIndex) => (
        <BlockItem
          key={block.id ?? blockIndex}
          block={block}
          blockIndex={blockIndex}
          activityIndex={activityIndex}
          sectionIndex={sectionIndex}
          totalBlocks={section.blocks.length}
          onRemove={() => removeSectionBlock(activityIndex, sectionIndex, blockIndex)}
        />
      ))}

      <Button
        type="dashed"
        onClick={() => addSectionBlock(activityIndex, sectionIndex)}
        icon={<PlusOutlined />}
        className="add-block-button"
      >
        Añadir bloque
      </Button>
    </div>
  );
};

export default ActivitySectionView;
